// dateUtils.js
export const convertDateFormat = (dateString) => {
    const [year, month, day] = dateString.split('-');
    return `${parseInt(month)}/${parseInt(day)}/${year}`;
  };
  